export default __webpack_public_path__ + "static/promo-text-d0d22e1d73e399f03e58533f907f1d87.svg";